import Api from '@/api/api'

export default {
    userList() {
       return Api.get('SaasAdmin/User/GetUsers');                     
    },
    removeUser(id){
        return Api.delete('SaasAdmin/User/DeleteUser?userId='+id);
    },
    addUsers(data){
        return Api.post('SaasAdmin/User/AddUser', data)
    },
    editUser(id){
        return Api.get('SaasAdmin/User/GetUserById?userID='+id);
    },
    updateUser(id, data) {
        return Api.put('SaasAdmin/User/UpdateUser?userId=' + id, data);
    },
    roleList(){
        return Api.get('SaasAdmin/api/Role/GetRoles');
    },
    addClient(clientData) {
        return Api.post('SaasAdmin/api/Client/Client', clientData);
    },
    updateClient(clientData) {
        return Api.put('SaasAdmin/api/Client', clientData);
    }
}